<template>

  <el-main
    class="main_content"
    style="padding: 0"
    v-loading="onloading"
  >
  <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="backList">用户管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>企业认证</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="contain_div">
      <ul class="cont_btns1" style="margin-bottom: 20px">
        <li>
          <el-button
            @click="backList"
            type="primary"
          >返回代理列表</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr">
        <el-steps :active="step" align-center style="margin-bottom: 50px">
          <el-step title="步骤1" description="设置企业信息"></el-step>
          <el-step title="步骤2" description="绑定手机号"></el-step>
          <el-step title="步骤3" description="采集营业执照"></el-step>
          <el-step title="步骤4" description="采集身份证"></el-step>
          <el-step title="步骤5" description="前往签约"></el-step>
        </el-steps>
        <div v-if="step == 1">
          <div></div>
          <div class="identity" style="margin-bottom: 20px">
            <el-input class="identity_input" v-model="code"></el-input>
            <el-button style="margin-left: 20px;height: 28px;line-height: 28px;padding: 0px 20px" type="primary" @click="startTime()">{{ time != 60 ? time : '发送验证码' }}</el-button>
          </div>
          <div style="display: flex;align-items: center;justify-content: center">
            <el-button type="primary" @click="doUpCode()">提交</el-button>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: center" v-if="step == 0 || step == 2 || step == 3">
          <el-form
            style="width:850px;"
            ref="form"
            :model="form"
            label-width="140px"
            :rules="formRule"
          >
            <el-form-item
              label="企业名称"
              prop='companyName'
              v-if="step == 0"
            >
              <el-input v-model="form.companyName" :disabled="companyStatus == 3" placeholder="请输入企业名称"></el-input>
            </el-form-item>

            <el-form-item
              label="统一社会信用编号"
              prop='uniCredit'
              v-if="step == 0"
            >
              <el-input v-model="form.uniCredit" :disabled="companyStatus == 3" placeholder="请输入统一社会信用编号"></el-input>
            </el-form-item>

            <el-form-item
              label="企业对公账户"
              prop='accountNo'
              v-if="step == 0"
            >
              <el-input v-model="form.accountNo" :disabled="companyStatus == 3" placeholder="请输入企业对公账户"></el-input>
            </el-form-item>

            <el-form-item
              label="开户银行名称"
              prop='parentBankName'
              v-if="step == 0"
            >
              <el-select v-model="form.parentBankName" :disabled="companyStatus == 3" clearable filterable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="开户行支行名称"
              prop='bankName'
              v-if="step == 0"
            >
              <el-input v-model="form.bankName" :disabled="companyStatus == 3" placeholder="请输入开户行支行名称"></el-input>
            </el-form-item>

            <el-form-item
              label="支付行号"
              prop='unionBank'
              v-if="step == 0"
            >
              <el-input maxlength="12" :disabled="companyStatus == 3" v-model="form.unionBank" placeholder="请输入支付行号"></el-input>
            </el-form-item>

            <el-form-item
              label="营业执照"
              prop="companyPic"
              v-if="step == 2"
            >
              <el-upload
                class="avatar-uploader"
                action="/manager/user/seven_app_file_up"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :data='tokenData'
              >
                <img
                  v-if="form.companyPic"
                  :src="form.companyPic"
                  class="avatar"
                >
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
                <div
                  slot="tip"
                  class="el-upload__tip"
                >只能上传jpg/png文件，文件大小不能超过700k</div>
              </el-upload>
            </el-form-item>

            <el-form-item
              label="法人身份证正面"
              prop="idFront"
              v-if="step == 3"
            >
              <el-upload
                class="avatar-uploader"
                action="/manager/user/seven_app_file_up"
                :show-file-list="false"
                :on-success="handleAvatarSuccess1"
                :before-upload="beforeAvatarUpload"
                :data='tokenData'
              >
                <img
                  v-if="form.idFront"
                  :src="form.idFront"
                  class="avatar"
                >
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
                <div
                  slot="tip"
                  class="el-upload__tip"
                >只能上传jpg/png文件，文件大小不能超过700k</div>
              </el-upload>
            </el-form-item>

            <el-form-item
              label="法人身份证反面"
              prop="idBack"
              v-if="step == 3"
            >
              <el-upload
                class="avatar-uploader"
                action="/manager/user/seven_app_file_up"
                :show-file-list="false"
                :on-success="handleAvatarSuccess2"
                :before-upload="beforeAvatarUpload"
                :data='tokenData'
              >
                <img
                  v-if="form.idBack"
                  :src="form.idBack"
                  class="avatar"
                >
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
                <div
                  slot="tip"
                  class="el-upload__tip"
                >只能上传jpg/png文件，文件大小不能超过700k</div>
              </el-upload>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="onSubmit('form')"
                :loading="addLoading"
              >立即上传</el-button>
              <el-button @click="resetForm('form')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="display: flex;align-items: center;justify-content: center" v-if="step == 4 && companyStatus == 6">
          <el-button type="primary" @click="getSignUrl()">前往签约</el-button>
        </div>
        <div style="display: flex;align-items: center;justify-content: center" v-if="step == 4 && companyStatus == 7">
          <span>已完成企业认证</span>
        </div>
      </div>
      <el-dialog
        title="签约中"
        :visible.sync="dialogEditVisible"
        width="20%"
        :before-close="signUrl"
      >
        <div style="display: flex;align-items: center;justify-content: center;flex-direction: column">
          <div>请前往签约页面完成签约，签约完成点击确定完成企业认证</div>
          <el-button type="primary" @click="signUrl()">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </el-main>
</template>


<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { bus } from "../../bus.js";
import { pca, pcaa } from "area-data";
import API from "../../api/api_user";
import UEditor from "@/components/ueditor.vue";
import {dateFunc} from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "companySet",
  components: { UEditor },
  data() {
    return {
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      addLoading: false,
      fileList2: [],
      pca: pca,
      pcaa: pcaa,

      editorOption: {
        name: "阿德恩"
      },
      form: {
        companyName: "",
        uniCredit: "",
        accountNo: "",
        parentBankName: "",
        bankName: "",
        unionBank: "",
        companyPic: null,
        idFront: null,
        idBack: null
      },
      formRule: {
        companyName: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        uniCredit: [{ required: true, message: "请填写统一社会信用编号", trigger: "blur" }],
        accountNo: [{ required: true, message: "请填写企业对公账户", trigger: "blur" }],
        parentBankName: [{ required: true, message: "请填写开户银行名称", trigger: "change" }],
        bankName: [{ required: true, message: "请填写开户行支行名称", trigger: "blur" }],
        unionBank: [
          { required: true, message: "请填写支付行号", trigger: "blur" },
          { min: 12, max: 12, message: '请输入12个字符', trigger: 'blur' }
        ],
        companyPic: [{ required: true, message: "请上传营业执照", trigger: "blur" }],
        idFront: [{ required: true, message: "请上传法人身份证正面", trigger: "blur" }],
        idBack: [{ required: true, message: "请上传法人身份证反面", trigger: "blur" }]
      },
      isCollapse: true,
      activeName: "second",
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: [
        {value: '西安银行', key: '04447910'},
        {value: '齐鲁银行', key: '04094510'},
        {value: '汉口银行', key: '04145210'},
        {value: '中国银行', key: '01040000'},
        {value: '广发银行', key: '03060000'},
        {value: '交通银行', key: '03010000'},
        {value: '浦东发展银行', key: '03100000'},
        {value: '大连银行', key: '04202220'},
        {value: '贵阳银行', key: '04437010'},
        {value: '华夏银行', key: '03040000'},
        {value: '河北银行', key: '04221219'},
        {value: '烟台银行', key: '04044560'},
        {value: '潍坊银行', key: '64624580'},
        {value: '枣庄银行', key: '05824540'},
        {value: '平安银行', key: '04105840'},
        {value: '杭州银行', key: '03133310'},
        {value: '杭州联合银行', key: '04023310'},
        {value: '汉口银行', key: '04140000'},
        {value: '北京农村商业银行', key: '14181000'},
        {value: '东莞农村商业银行', key: '14156020'},
        {value: '农信福建', key: '14173900'},
        {value: '农信安徽', key: '14473600'},
        {value: '农信山东', key: '14144500'},
        {value: '浙江泰隆商业银行', key: '03133450'},
        {value: '泰安商行', key: '05284630'},
        {value: '农信河南', key: '14404900'},
        {value: '日照银行', key: '04554770'},
        {value: '威海银行', key: '04814650'},
        {value: '东营银行', key: '05274550'},
        {value: '济宁银行', key: '05374610'},
        {value: '渤海银行', key: '03170000'},
        {value: '恒丰银行', key: '03110000'},
        {value: '德州银行',key: '05154680'},
        {value: '山东农信社',key: '14144500'},
        {value: '临商银行',key: '04314730'},
        {value: '青岛银行',key: '04504520'},
        {value: '上海银行',key: '04012900'},
        {value: '广西农信社',key: '14436100'},
        {value: '农村商业银行',key: '0314'},
        {value: '晋中市商业银行',key: '05605110'},
        {value: '上饶市商业银行',key: '05264330'},
        {value: '农信内蒙',key: '14511900'},
        {value: '农信湖南',key: '14385500'},
        {value: '深圳农村商业银行',key: '1404'},
        {value: '农村信用社',key: '14367000'},
        {value: '南京银行',key: '04243010'},
        {value: '宁波银行',key: '04083320'},
        {value: '北京银行',key: '04031000'},
        {value: '光大银行',key: '03030000'},
        {value: '湖北农信社',key: '14105200'},
        {value: '钦州市钦南国民村镇银行',key: '15366310'},
        {value: '招商银行',key: '03080000'},
        {value: '成都商业银行',key: '04296510'},
        {value: '中信银行',key: '03020000'},
        {value: '民生银行',key: '03050000'},
        {value: '成都银行',key: '3136'},
        {value: '农村村镇银行',key: '15584712'},
        {value: '莱商银行',key: '04974790'},
        {value: '锦州银行',key: '04392270'},
        {value: '郑州市市郊农村信用合作联社',key: '402491007010'},
        {value: '浙商银行',key: '0316'},
        {value: '湖北农信',key: '14105200'},
        {value: '成都农村商业银行',key: '14226510'},
        {value: '天津农村商业银行',key: '14191100'},
        {value: '广东南粤银行',key: '04895910'},
        {value: '浦北国民村镇银行',key: '0320'},
        {value: '钦南国民村镇银行',key: '15366310'},
        {value: '江西赣州银座村镇银行',key: '15204280'},
        {value: '焦作中旅银行股份有限公司',key: '04115010'},
        {value: '农信福建',key: '04023910'},
        {value: '湖北三峡农村商业银行',key: '04025350'},
        {value: '台州银行',key: '04593451'},
        {value: '江苏长江商业银行股份有限公司',key: '04933160'},
        {value: '盛京银行',key: '03132210'},
        {value: '石河子国民村镇银行',key: '14448800'},
        {value: '郑州银行',key: '04354910'},
        {value: '新疆石河子交银村镇银行',key: '03209028'},
        {value: '内蒙农信',key: '04021910'},
        {value: '东亚银行',key: '05026530'},
        {value: '丹东银行',key: '04462262'},
        {value: '遂宁银行',key: '03136620'},
        {value: '晋城银行',key: '03131680'},
        {value: '长安银行',key: '03137950'},
        {value: '包商银行股份有限公司鞍山道支行',key: '313192000110'},
        {value: '成都银行',key: '04296510'},
        {value: '长治银行',key: '05121660'},
        {value: '长沙农村商业银行',key: '31455100'},
        {value: '武汉农村商业银行',key: '04025210'},
        {value: '南充农村商业银行',key: '03146730'},
        {value: '青岛农商银行',key: '402452007125'},
        {value: '泸州商业银行',key: '03136570'},
        {value: '重庆农村商业银行',key: '14136900'},
        {value: '平顶山银行股份有限公司',key: '05484950'},
        {value: '江苏江南农村商业银行',key: '03143040'},
        {value: '龙江银行',key: '04922600'},
        {value: '营口银行',key: '64652280'},
        {value: '辽阳银行',key: '04192310'},
        {value: '青岛胶南海汇村镇银行',key: '320452200015'},
        {value: '乐山市商业银行',key: '05406650'},
        {value: '企业银行',key: '0596'},
        {value: '徽商银行',key: '0319'},
        {value: '村镇银行有限公司',key: '0320'},
        {value: '承德银行',key: '05131419'},
        {value: '洛阳银行',key: '04184930'},
        {value: '贵州银行',key: '05847000'},
        {value: '重庆三峡银行',key: '0542'},
        {value: '乐山银行',key: '03136650'},
        {value: '农村信用社',key: '04020000'},
        {value: '广东省农村信用社联合社',key: '14505800'},
        {value: '中国农业发展银行',key: '0203'},
        {value: '合肥科技农村商业银行',key: '04023610'},
        {value: '北京顺义银座村镇银行',key: '15201000'},
        {value: '建设银行',key: '01050000'},
        {value: '中国建设银行',key: '01050000'},
        {value: '农业银行',key: '01030000'},
        {value: '中国农业银行',key: '01030000'},
        {value: '中国农业银行股份有限公司',key: '01030000'},
        {value: '中国民生银行',key: '03050000'},
        {value: '中国邮储银行',key: '01000000'},
        {value: '中国工商银行',key: '01020000'},
        {value: '浦发银行',key: '03100000'},
        {value: '汇丰银行',key: '25120344'},
        {value: '华商银行',key: '03370000'},
        {value: '南昌银行',key: '04484210'},
        {value: '绵阳商行',key: '04856590'},
        {value: '江西农信',key: '14394200'},
        {value: '广东南粤银行',key: '0489'},
        {value: '包商银行',key: '04791920'},
        {value: '哈尔滨市商业银行',key: '04422610'},
        {value: '深圳农村商业银行',key: '14045840'},
        {value: '农信银',key: '0402'},
        {value: '中原银行股份有限公司',key: '05864910'},
        {value: '长安银行',key: '05417900'},
        {value: '大华银行（中国）',key: '03340000'},
        {value: '华侨永亨银行股份有限公司',key: '25060344'},
        {value: '韩亚银行（中国）',key: '03290000'},
        {value: '华融湘江',key: '05705500'},
        {value: '湖南三湘银行',key: '03235510'},
        {value: '吉林银行',key: '04512420'},
        {value: '兴业银行',key: '03090000'},
        {value: '湖北银行',key: '05755200'},
        {value: '晋商银行',key: '04491610'},
        {value: '盛京银行',key: '04170000'},
        {value: '齐商银行',key: '04384530'},
        {value: '江苏银行',key: '05083000'},
        {value: '浙江泰隆商业银行',key: '64733450'},
        {value: '广西北部湾银行',key: '64786110'},
        {value: '遂宁银行',key: '05516620'},
        {value: '江苏江南农村商业银行',key: '14603040'},
        {value: '常熟市农村商业银行',key: '14030001'},
        {value: '浙商银行',key: '03160000'},
        {value: '徽商银行',key: '64403600'},
        {value: '北京农商行',key: '14181001'},
        {value: '尧都农信社',key: '14341770'},
        {value: '武汉农村商业银行',key: '14595210'},
        {value: '深圳农村商业银行',key: '14040000'},
        {value: '顺德农村商业银行',key: '65085883'},
        {value: '重庆农商行',key: '14136530'},
        {value: '福建海峡银行股份有限公司',key: '04053910'},
        {value: '四川天府银行',key: '03130000'},
        {value: '东莞银行',key: '04256020'},
        {value: '上海农商行',key: '14012900'},
        {value: '工商银行',key: '01020000'},
        {value: '广州银行',key: '04135810'},
        {value: '温州银行',key: '05063330'},
        {value: '哈尔滨银行',key: '64422610'},
        {value: '长沙银行',key: '04615510'},
        {value: '泉州银行',key: '04643970'},
        {value: '营口银行',key: '04652280'},
        {value: '邮储银行',key: '01000000'},
        {value: '东亚银行',key: '63200000'},
        {value: '南洋商业银行',key: '03320000'},
        {value: '恒生银行',key: '25140344'},
        {value: '晋城银行',key: '05031680'},
        {value: '集友银行有限公司',key: '25210344'},
        {value: '创兴银行有限公司',key: '25170344'},
        {value: '星展银行(中国)有限公司',key: '03240000'},
        {value: '永亨银行(中国)有限公司',key: '03300000'},
        {value: '永隆银行',key: '25100344'},
        {value: '花旗银行(中国)有限公司',key: '03190001'},
        {value: '日本三菱信用卡公司',key: '27090392'},
        {value: '日本三井住友银行股份有限公司',key: '26110392'},
        {value: '友利银行(中国)有限公司',key: '03270000'},
        {value: '武汉农商银行',key: '14105210'},
        {value: '广东南海农村商业银行',key: '14075882'},
        {value: '广州农村商业银行股份有限公司',key: '14055810'},
        {value: '华一银行',key: '03390000'},
        {value: '城市商业银行',key: '0313'},
        {value: '厦门国际银行',key: '05870000'},
        {value: '重庆三峡银行',key: '05426900'},
        {value: '渣打银行中国有限公司',key: '03220000'},
      ],
      step: null,
      userId: "",
      code: '',
      time: 60,
      setInterval1: '',
      companyStatus: null,
      dialogEditVisible: false,
      onloading: false
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  created() {
    var id = ""
    if (this.$route.query.userId) {
      id = this.$route.query.userId;

    } else {

    }
    if (this.$route.query.back && this.$route.query.back != null)
    {
      this.backType = this.$route.query.back;
    }
    this.userId = id;
    this.getUserInfo()
  },
  methods: {
    signUrl () {
      this.dialogEditVisible = false
      this.getUserInfo()
    },
    getSignUrl () {
      let that = this;

      let params = {
        token: localStorage.getItem("api_token"),
        userId: this.userId
      };
      API.get_sign_url(params)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.dialogEditVisible = true
              window.open(result.message, '_blank')

            }
          },
          function(err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.companyPic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess1: function(e) {
      if (e.key == 1000) {
        this.form.idFront = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess2: function(e) {
      if (e.key == 1000) {
        this.form.idBack = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    doUpCode () {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        userId: this.userId,
        code: this.code
      };
      if (!this.code || this.code == null || this.code == '')
      {
        that.$message.error({
            showClose: true,
            message: "请填写验证码",
            duration: 2000
          });
          return;
      }
      API.user_bind_tel(params)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.code = ""
              that.time = 1
              that.getUserInfo()
              that.$message.success({
                showClose: true,
                message: "提交成功",
                duration: 2000
              });
            } else {
              that.$message.error({
              showClose: true,
              message: '绑定失败',
              duration: 2000
            });
            }
          },
          function(err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    startCode () {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        userId: this.userId
      };
      API.tong_code(params)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.$message.success({
                showClose: true,
                message: "发送成功",
                duration: 2000
              });
            }
          },
          function(err) {
            that.listLoading20 = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading20 = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    startTime () {
      if (this.time != 60) return
      clearInterval(this.setInterval1)
      this.time = 59
      this.setInterval1 = setInterval(() => {
        if (this.time < 0 || this.time == 0) {
          clearInterval(this.setInterval1)
          this.time = 60
        } else {
          this.time -= 1
        }
      }, 1000)
      this.startCode()
    },
    getUserInfo () {
      var that = this;
      API.get_companyInfo({
        token: localStorage.getItem("api_token"),
        userId: this.userId
      })
        .then(
          function(result) {
            that.addLoading = false;
            if (result.key == 1000) {
              that.companyStatus = result.result.map.companyStatus;
              //企业认证进度：1-创建会员，2：绑定手机号，3：设置企业信息（审核中），4：设置企业信息（已审核），5：已采集营业执照，6：已采集身份证，7：已签约
              if (that.companyStatus == 1) {
                that.step = 0//待设置企业信息
              } else if (that.companyStatus == 2) {
                that.step = 2//待提交营业执照
              } else if (that.companyStatus == 3) {
                that.step = 0//企业信息审核中
              } else if (that.companyStatus == 4) {
                that.step = 1//待绑定手机号
              } else if (that.companyStatus == 5) {
                that.step = 3//待上传身份证
              } else if (that.companyStatus == 6) {
                that.step = 4//待签约
              } else if (that.companyStatus == 7) {
                that.step = 4//已签约
                // that.$route.query.back;
              }
              console.log('au：' + that.step)
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.loading = false;
            console.error(err);
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    backList() {
      this.$router.push({
        path: "/normal_user_list"
      });
    },
    onEditorReady(editor) {},
    handleRemove(file, fileList) {
      for (var i = 0; i < this.fileList2.length; i++) {
        if (this.fileList2[i].name == file.name) {
          this.fileList2.splice(i, 1);
          return;
        }
      }
    },
    handlePreview(file) {},

    beforeAvatarUpload: function(e) {},
    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          that.addLoading = true;
          console.log('au11：' + that.step)
          if (that.step == 0) {
            that.setCompanyInfo()
          } else if (that.step == 2) {
            that.idcardCollect(1)
          } else if (that.step == 3) {
            console.log('au166：' + that.step)
            that.idcardCollect(2)
          }
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    idcardCollect (type) {

      let that = this;
      console.log('au33：' + that.step)
      let para = {
        token: localStorage.getItem("api_token"),
        userId: that.userId,
        picType: type
      };
      if (type == 1) {
        para.companyPic = that.form.companyPic
      }
      if (type == 2) {
        para.idFront = that.form.idFront
        para.idBack = that.form.idBack
      }
      API.idcardCollect(para)
        .then(
          function(result) {
            that.addLoading = false;
            if (result.key == 1000) {
              that.onloading = true
              setTimeout(() => {
                that.onloading = false
                that.getUserInfo()
              }, 3000)
              that.$message.success({
                showClose: true,
                message: "上传成功",
                duration: 1500
              });
              // resetForm();
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    setCompanyInfo () {
      let that = this;
      let para = {
        companyName: that.form.companyName,
        uniCredit: that.form.uniCredit,
        accountNo: that.form.accountNo,
        parentBankName: that.form.parentBankName,
        bankName: that.form.bankName,
        unionBank: that.form.unionBank,
        token: localStorage.getItem("api_token"),
        userId: that.userId
      };
      API.set_company_info(para)
        .then(
          function(result) {
            that.addLoading = false;
            if (result.key == 1000) {
              that.getUserInfo()
              that.$message.success({
                showClose: true,
                message: "上传成功",
                duration: 1500
              });
              // resetForm();
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    resetForm() {
      let that = this;
      that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.identity{
  display: flex;
  align-items: center;
  justify-content: center;
}
.identity .identity_input{
  width: 200px;
}
.identity div{
  width: 100px;
  margin-left: 20px;
}


.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}
.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}
.area-select {
  height: 40px;
}
.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/user/companySet.vue